import React from 'react';
import styled, { css } from 'styled-components';
import { func, bool } from 'prop-types';
import { marginMixin } from '@mixins';

const {
  margin,
  marginTop,
  marginRight,
  marginBottom,
  marginLeft,
} = marginMixin;

const Checkbox = ({
  onCheckedStateChange,
  isChecked,
}) => (
  <StyledCheckbox
    onClick={onCheckedStateChange}
    className={isChecked && 'checkbox-active'}
    margin={margin}
  >
    <Checkmark className={isChecked && 'checkmark-active'} viewBox="0 0 24 24">
      <polyline points="20 6 9 17 4 12" />
    </Checkmark>
  </StyledCheckbox>
);

const Checkmark = styled.svg`
  fill: none;
  stroke: white;
  stroke-width: 2px;

  polyline {
    visibility: visible;
  }
`;

const StyledCheckbox = styled.div`
  ${({ theme: { color } }) => css`
    ${margin}
    ${marginTop}
    ${marginRight}
    ${marginBottom}
    ${marginLeft}

    width: 33px;
    height: 33px;
    display: inline-block;
    background-color: ${color.white};
    border: 2px solid ${color.strawberry};
    border-radius: 4px;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;

    &.checkbox-active {
      background-color: ${color.strawberry};
    }

    ${Checkmark} {
      visibility: hidden;
      color: ${color.white};

      &.checkmark-active {
        visibility: visible;
      }
    }
  `};
`;

Checkbox.propTypes = {
  onCheckedStateChange: func.isRequired,
  isChecked: bool.isRequired,
};

export default Checkbox;
